import useSWR from 'swr';
import PackageProviderService from 'services/settings/ppoints/PackageProviderService';
import swrConfig from 'utils/swrConfig';

export const usePackageProviders = () => {
    const { data, error, isLoading } = useSWR(
        'package-providers',
        () => PackageProviderService.getAllCached(),
        swrConfig
    );

    return { packageProviders: data, error, isLoading };
};
